import { RateAgreementBidPack } from "./RateAgreementBidPack";

export interface RateAgreement {
  Id: number;
  AssignedBidPacks: RateAgreementBidPack[];
  CarrierId: number;
  Description: string;
  EndDate?: Date | null;
  RateAgreementNumber: number;
  StartDate: Date | null;
  Version: number;
}

export const defaultRateAgreement: RateAgreement = {
  Id: 0,
  AssignedBidPacks: [],
  CarrierId: 0,
  Description: "",
  EndDate: null,
  RateAgreementNumber: 0,
  StartDate: null,
  Version: 0,
};
